<template>
    <div class="row accordion-element">
        <div class="col">
            <Accordion>
                <AccordionTab header="Mise en évaluation">
                    <p v-if="!liaisonsEvaluation"> ... </p>
                    <p v-else>
                        <span v-for="liaison in liaisonsEvaluation.liste" :key="liaison.cle">
                            <div class="row">
                                <span v-for="jeu in liaison.jeuxEvaluation.liste" :key="jeu.jeu">
                                    <div class="col-10 offset-1 ">
                                        <h5 class="text-left">Jeux choisis: {{ jeu.jeuAfficher }}</h5>

                                    </div>
                                </span>
                                <div class="col-10 offset-1 border-white ">
                                    <h5 class="text-left">Mise</h5>
                                    <div class="row">
                                        <div class="col-2 lbl">
                                            <label>Minimum :</label>
                                        </div>
                                        <div class="col-2">
                                            {{ $commun.formatCurrency(liaison.minimumMise) }}
                                        </div>
                                        <div class="col-2 lbl">
                                            <label>Moyenne :</label>
                                        </div>
                                        <div class="col-2">
                                            {{ $commun.formatCurrency(liaison.moyenneMise) }}
                                        </div>
                                        <div class="col-2 lbl">
                                            <label>Maximum :</label>
                                        </div>
                                        <div class="col-2">
                                            {{ $commun.formatCurrency(liaison.maximumMise) }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-2 lbl">
                                            <label>Gains/Pertes :</label>
                                        </div>
                                        <div class="col-2" >
                                            {{ $commun.formatCurrency(liaison.gainPerte)}}
                                        </div>
                                        <div class="col-4">
                                            <label>(Mettre un signe moins (-) si pertes d'$)</label>
                                        </div>
                                        <div class="col-2 lbl">
                                            <label>Total :</label>
                                        </div>
                                        <div class="col-2">
                                            {{ $commun.formatCurrency(liaison.totaleMise) }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-10 offset-1 ">
                                    <h5 class="text-left">Temps de jeu</h5>
                                    <div class="row">
                                        <div class="col-2 lbl">
                                            <label>Minimum :</label>
                                        </div>
                                        <div class="col-2">
                                            {{ liaison.minimumTempsJeu }} (total en minutes)
                                        </div>
                                        <div class="col-2 lbl">
                                            <label>Maximum :</label>
                                        </div>
                                        <div class="col-2">
                                            {{ liaison.maximumTempsJeu }} (total en minutes)
                                        </div>
                                        <div class="col-2 lbl">
                                            <label>Total :</label>
                                        </div>
                                        <div class="col-2">
                                            {{ liaison.totalTempsJeu }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-10 offset-1 ">
                                    <h5 class="text-left">Fréquence des visites</h5>
                                    <div class="row">
                                        <div class="col-3 lbl center">
                                            <label>Année - Mois</label>
                                        </div>
                                        <div class="col-3 lbl center">
                                            <label>Nombre de fois</label>
                                        </div>
                                        <div class="col-4 lbl center">
                                            <label>Gains/Pertes</label>
                                        </div>
                                    </div>
                                     <span v-for="visite in liaison.visitesEvaluation.liste" :key="visite.cle">
                                        <div class="row">
                                            <div class="col-3 center">
                                                {{ visite.periode }}
                                            </div>
                                            <div class="col-3 center">
                                                {{ visite.nombreVisites }}
                                            </div>
                                            <div class="col-4 center">
                                                {{ visite.gainPerte }}
                                            </div>
                                        </div>
                                     </span>
                                 </div>
                            <hr></div>
                        </span>
                    </p>
                </AccordionTab>
            </Accordion>
        </div>
    </div>
</template>
<script>
import {mapState} from "vuex";

export default {
    name: 'LiaisonsMiseEvaluation',
    props: ['liaisonsEvaluation'],
  data() {
    return {
        storeModule: this.$root.$refs.breadcrumbComp.source.nom,
        jeuxDisponibles: [],
        rightJeuxChoisis: [],
        leftJeuxDisponibles: [],
    };
  },
  computed: mapState({
    state (state) {
      return state[this.storeModule]
    },
  }),
}
</script>